module.exports = __webpack_public_path__ + "static/app-en@2x-ef061b2549061a3180e9ac120cf96ae9.png";